import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { PROMOTION_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { PromoItemTypePage } from '@/features/promotion/pages/PromoItemTypePage';
import { promoCatalogueSearchSchema } from '@/features/promotion/types/promotion.types';

export const Route = createFileRoute('/_auth/promotion/item-types')({
  beforeLoad: () => requirePermission(PROMOTION_PERMISSIONS.ITEM_TYPE_VIEW),
  validateSearch: promoCatalogueSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Promotional Item Type">
      <Suspense fallback={<PageLoader />}>
        <PromoItemTypePage />
      </Suspense>
    </ErrorBoundary>
  ),
});
